jQuery(document).ready(function(){

  /*****************************************
      Control Mobile Menu
  *****************************************/
  jQuery('#mobile-menu').click(function(){
    jQuery('#top-bar-menu').toggleClass('active');

  });

  
 
  /***********************************************
      ACTIVATE MOBILE MENU BUILD
  ************************************************/
  jQuery('body').mobilemenu({
    opening_selector: "#mobile-menu",
    structureID: "#mobile-menu-wrapper",
    closing_selector: ".close-menu"
    }
  );
  jQuery('body').mainmenu({
      structureID: "#sidebar-menu-wrapper"
    }
  );
});
/***********************************************
    DESKTOP SCRIPTS FOR MENU
************************************************/



/***********************************************
    MOBILE SCRIPTS FOR MENU
************************************************/

(function ( $ ) {
  $.fn.mainmenu = function( options) {
    var settings = $.extend({
            opening_selector: '.opening_class',
            structureID: '#structureID',
           closing_selector: '.closing_class'
        }, options );

    $('#sidebar-menu-sections .menu-section-wrapper').hide();
    return this.each(function() {

      // OPENS THE MENU
      $(document).on('click', settings.opening_selector, function(e){
        e.preventDefault();
        $('body').toggleClass('mobile-menu-open');
        $(settings.opening_selector).toggleClass('open');
        $(settings.structureID).toggleClass('open');
      });
      // CLOSES THE MENU
      $(document).on('click', settings.closing_selector, function(e){
        e.preventDefault();
        $(settings.closing_selector).removeClass('open');
        $(settings.structureID).removeClass('open');
      });
      $(document).on('click', settings.structureID+ " .section-selector.menu-item-has-children", function(e){
        e.preventDefault();
        var section = ".section_" + $(this).data('id');
        $('.on').removeClass('on');
        $(this).parent().addClass('on');
        $('.menu-section-wrapper').hide();
        $(section).addClass('open').show();
      });
      $(document).on('click', settings.structureID + ' .back',function(e){
        e.preventDefault();
        $('.top', settings.structureID).removeClass('on');
        $('.menu-section-wrapper').removeClass('open').hide();
      });
      $(document).on('click', settings.structureID+ ' .section-label',function(e){
        e.preventDefault();
        if(!$(this).hasClass('active'))
        {
          $('.active').removeClass('active');
          $('.sub-items').slideUp();
          $(this).addClass('active').siblings('.sub-items').slideToggle();
        }
      });
    });
  };
	$.fn.mobilemenu = function( options) {
		var settings = $.extend({
            opening_selector: '.opening_class',
			structureID: '#structureID',
			closing_selector: '.closing_class'
        }, options );

    $('#mobile-menu .menu-section-wrapper').hide();
		return this.each(function() {

			// OPENS THE MENU
			$(document).on('click', settings.opening_selector, function(e){
				e.preventDefault();
        $('body').toggleClass('mobile-menu-open');
        $(settings.opening_selector).toggleClass('open');
				$(settings.structureID).toggleClass('open');
			});
			// CLOSES THE MENU
			$(document).on('click', settings.closing_selector, function(e){
				e.preventDefault();
				$(settings.closing_selector).removeClass('open');
				$(settings.structureID).removeClass('open');
			});
			$(document).on('click', settings.structureID+ " .section-selector.menu-item-has-children", function(e){
				e.preventDefault();
				var section = ".section_" + $(this).data('id');
				$('.on').removeClass('on');
				$(this).parent().addClass('on');
				$('.menu-section-wrapper').hide();
        $(section).show();
			});
			$(document).on('click', settings.structureID + ' .back',function(e){
				e.preventDefault();
				$('.top', settings.structureID).removeClass('on');
        $('.menu-section-wrapper').hide();
			});
			$(document).on('click', settings.structureID+ ' .section-label',function(e){
				e.preventDefault();
				if(!$(this).hasClass('active'))
				{
					$('.active').removeClass('active');
					$('.sub-items').slideUp();
					$(this).addClass('active').siblings('.sub-items').slideToggle();
				}
			});
		});
	};
/*
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  if($('.offset_form').length)
  {
    $('.request_demo_btn').click(function(e){
        e.preventDefault();
        $('html, body').animate({ scrollTop: ($('#form_scroll_to').offset().top - 180) },2000);
    });
  }
  
  var scrollTimer;
  $(window).bind('scroll', function() {

      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        //footer
        var test = $('#hide_button_when_visisble').isInViewport();
        if(test)
        {
            $('#sidebar nav').addClass('fixed');
            //$('.request_demo_btn').fadeOut(200);
        }
        else {
            $('#sidebar nav').removeClass('fixed');
            //$('.request_demo_btn').fadeIn(200);
        }
      },100);

  });
  */




}( jQuery ));
